import { useEffect, useState } from "react";

export const PREVIEW_DEBOUNCE_MS = 300;

/** `resetKey` writes `value` through in the same render so a type change cannot POST the previous body. */
export function useDebouncedValue<T>(value: T, delayMs: number, resetKey?: unknown): T {
  const [seenKey, setSeenKey] = useState(resetKey);
  const [debounced, setDebounced] = useState(value);
  if (resetKey !== seenKey) {
    setSeenKey(resetKey);
    setDebounced(value);
  }
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
